export enum FeedProductModals {
	INSTALL = 'installJobModal',
	REPAIR = 'repairJobModal',
	REMOVAL = 'removeJobModal',
	CANCEL = 'confirmRemovalModal',
	PROVISION = 'ProvisionFeedTankModal',
	INSTALL_FEED_TANK = 'InstallFeedTankModal',
}
